import angular from 'angular';
import RouterResolver from './router-resolver';
import RouterListener from './router-listener';
import Routes from './routes';


const moduleName = 'atc-routing';
angular.module(moduleName, [])
    .provider('routerResolver', RouterResolver)
    .config(Routes)
    .run(RouterListener)
;


export default moduleName;